import { useAct } from 'FlowBuilder/store'
import SurveyAction from './SurveyAction'
import './Sidebar.scoped.scss'
import Button from 'Shared/components/Button'
import orderActions from 'FlowTaker/lib/orderActions'
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';

const KIND_MAPPINGS = {
  'redirect': 'Redirect',
  'fundraise_up': 'Fundraise Up',
  'email_to_target': 'Email To Target'
}

export default function Sidebar() {
  const act = useAct()
  const actions = useSel(s => _.values(s.actions.entities) || [])
  const orderedActions = orderActions(actions)
  const navItem = useSel(s => s.local.navItem)
  const selectedActionId = useSel(s => s.local.selectedActionId)

  useEffect(() => {
    if (navItem === 'setup') {
      act.builder.selectAction(null)
    } else if (selectedActionId === null) {
      act.builder.selectAction(orderedActions[0]?.id)
    }
  }, [selectedActionId, navItem])


  const onDragEnd = (result) => {
    const { draggableId, destination } = result;
    if (!destination) return;

    const isNumericString = /^\d+$/.test(draggableId);
    const actionId = isNumericString ? parseInt(draggableId) : draggableId // can be uuid, in which case leave as string
    act.actions.moveAction(actionId, destination.index)
  }

  return <div className="flow-sidebar">
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId="actions" type="action">
        {(provided) => (
          <div
            ref={provided.innerRef}
            {...provided.droppableProps}
          >
            {orderedActions.map((action, index) =>
              <ActionContainer draggableId={action.id} index={index} key={action.id}>
                <Action key={action.id} action={action} index={index} />
              </ActionContainer>)}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>

    {navItem === 'build' && <Button secondary onClick={() => act.local.setModal({ kind: 'addAction' })}>
      <SvgIconsPlus /> Add step
    </Button>}
  </div>
}

function ActionContainer({ draggableId, index, children }) {
  const navItem = useSel(s => s.local.navItem);

  if (navItem === 'build') {
    return (<Draggable draggableId={String(draggableId)} index={index}>
      {(provided) => (
        <div
          ref={provided.innerRef}
          {...provided.draggableProps}
          className="question row"
        >
          <div {...provided.dragHandleProps} className="drag-handle action">⣿</div>
          {children}
        </div>
      )}
    </Draggable>)
  }
  return <div>{children}</div>
}

function Action({ action, index }) {
  const act = useAct()
  const { name, kind } = action
  const navItem = useSel(s => s.local.navItem)
  const selectedActionId = useSel(s => s.local.selectedActionId)
  const selected = selectedActionId === action.id

  if (kind === 'survey') {
    return <SurveyAction action={action} />
  }

  function remove(e) {
    e.stopPropagation()
    act.actions.markInactive(action.id)
  }

  return <div className={`box cursor-pointer ${selected ? 'dark-outline' : ''} margin-bottom`} onClick={() => act.builder.selectAction(action.id)}>
    <div className='row justify-space-between'>
      <p className='title'>{KIND_MAPPINGS[kind] || name}</p>
      {navItem === 'build' && <div onClick={remove}><SvgIconsDelete /></div>}
    </div>
  </div>
}
